import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { errorMessage, successMessage } from "../CommonFunctions";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  Row,
  Nav,
  Tab,
} from "react-bootstrap";

import {
  POST_GetTestingsNDTApprovalDetailByID,
  POST_TestingsApprovalInsert,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import CustomInput from "../../../CustomControls/CustomInput";

const TestingNDTApproval = ({
  showTestingNDTApprovalModal,
  setShowTestingNDTApprovalModal,
  InwardMaterialID,
  fnCallback,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const [showTCAllTestApprovalModal, setShowTCAllTestApprovalModal] =
    useState(false);

  const [showTestMasterImagesModal, setShowTestMasterImagesModal] =
    useState(false);

  const [showTestingResultImagesModal, setShowTestingResultImagesModal] =
    useState(false);
  const [listTestMasterImages, setListTestMasterImages] = useState([]);
  const [listOfTestingResultImages, setListOfTestingResultImages] = useState(
    []
  );
  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);

  const [showTPIDetailModal, setShowTPIDetailModal] = useState(false);
  const [listOfTPIDetails, setListOfTPIDetails] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const ListOfFormsPT = [
    { label: "Detail", FormNo: 1 },
    { label: "Material", FormNo: 2 },
  ];

  const ListOfFormsMT = [
    { label: "Detail", FormNo: 1 },
    { label: "Equipment", FormNo: 2 },
    { label: "Material", FormNo: 3 },
  ];

  const ListOfUT = [
    { label: "Detail", FormNo: 1 },
    { label: "Equipment", FormNo: 2 },
    { label: "Prob", FormNo: 3 },
  ];

  const validationSchemaApproval = Yup.object().shape({});

  const formikApproval = useFormik({
    validationSchemaApproval,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitApproval(values, formikHelpers),
    initialValues: {
      InwardMaterialIDEncrypted: "",
      ApprovalTCNo: "",
      ApprovalInwardNo: "",
      InwardDate: "",
      EDD: "",
      LetterRefNo: "",
      Size: "",
      Condition: "",
      SampleDetail: "",
      ListOfMaterialTests: [],
      ApprovalNoteForApproveAll: "",
      ListOfLetterRefDoc: [],
      IsMaterialReturnable: false,
      IsTPIRequired: false,
      IsHold: false,
      IsNDT: false,
      NDTProcessType: 0,
      DieNo: "",
      HeatNo: "",
      DRGNo: "",
      Thikness: "",
      AreatoBeCovered: "",
      RadiationEnergy: "",
      Density: "",
      Sensitivity: "",
      MaterialName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardMaterialIDEncrypted,
      ApprovalTCNo,
      ApprovalInwardNo,
      InwardDate,
      EDD,
      LetterRefNo,
      Size,
      Condition,
      SampleDetail,
      ListOfMaterialTests,
      ApprovalNoteForApproveAll,
      ListOfLetterRefDoc,
      IsMaterialReturnable,
      IsTPIRequired,
      IsHold,
      IsNDT,
      NDTProcessType,
      DieNo,
      HeatNo,
      DRGNo,
      Thikness,
      AreatoBeCovered,
      RadiationEnergy,
      Density,
      Sensitivity,
      MaterialName,
    },
  } = formikApproval;

  const handleValidSubmitApproval = (values) => {};

  const getTCDetailForTestingApproval = async (inwardMaterialID) => {
    setIsLoading(true);
    await post(POST_GetTestingsNDTApprovalDetailByID, {
      InwardMaterialIDEncrypted: inwardMaterialID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikApproval.setFieldValue(
            "InwardMaterialIDEncrypted",
            inwardMaterialID
          );
          formikApproval.setFieldValue("ApprovalTCNo", response?.TCNo);
          formikApproval.setFieldValue("ApprovalInwardNo", response?.InwardNo);
          formikApproval.setFieldValue("InwardDate", response?.InwardDate);
          formikApproval.setFieldValue("EDD", response?.ExpectedDateOfDelivery);

          formikApproval.setFieldValue("Size", response?.Size);
          formikApproval.setFieldValue("Condition", response?.Condition);
          formikApproval.setFieldValue("SampleDetail", response?.SampleDetail);

          formikApproval.setFieldValue("IsNDT", response?.IsNDT);
          formikApproval.setFieldValue("DieNo", response?.DieNo);
          formikApproval.setFieldValue("HeatNo", response?.HeatNo);
          formikApproval.setFieldValue("DRGNo", response?.DRGNo);
          formikApproval.setFieldValue("Thikness", response?.Thikness);
          formikApproval.setFieldValue(
            "AreatoBeCovered",
            response?.AreatoBeCovered
          );
          formikApproval.setFieldValue(
            "RadiationEnergy",
            response?.RadiationEnergy
          );
          formikApproval.setFieldValue("Density", response?.Density);
          formikApproval.setFieldValue("Sensitivity", response?.Sensitivity);
          formikApproval.setFieldValue("MaterialName", response?.MaterialName);

          formikApproval.setFieldValue(
            "ListOfMaterialTests",
            response?.ListOfMaterialTests?.map((x) => ({
              TestingIDEncrypted: x?.TestingIDEncrypt,
              InwardMaterialTestDetailIDEncrypted:
                x?.InwardMaterialTestDetailIDEncrypt,
              InwardMaterialIDEncrypted: x?.InwardMaterialIDEncrypt,
              DepartmentIDEncrypt: x?.DepartmentIDEncrypt,
              DepartmentName: x?.DepartmentName,
              MaterialGroupIDEncrypt: x?.MaterialGroupIDEncrypt,
              MaterialGroupName: x?.MaterialGroupName,
              MaterialTypeIDEncrypt: x?.MaterialTypeIDEncrypt,
              MaterialType: x?.MaterialType,
              InwardIDEncrypted: x?.InwardIDEncrypt,
              TestMasterIDEncrypted: x?.TestMasterIDEncrypt,
              TestName: x?.TestName,
              TestingDate: x?.TestingDate,
              TestingToDate: x?.TestingToDate,
              TestingQty: x?.TestCount,
              LocationTypeName: x?.LocationTypeName,
              // TestMethodIDEncrypted: x?.TestMethodIDEncrypt,
              // TestMethodName: x?.TestMethod,
              MachineIDEncrypted: x?.MachineIDEncrypt,
              MachineName: x?.MachineName,
              ReferenceStandardIDEncrypted: x?.ReferenceStandardIDEncrypt,
              ReferenceStandardName: x?.ReferenceStandard,
              TestedByEmployeeNames: x?.TestedBy,
              Result: x?.Result,
              Remarks: x?.Remarks,
              TestingStatus: x?.TestingStatus,
              ChangeNote: x?.ChangeNote,
              btnStatus: 4,
              ApprovalNote: x?.ApprovalNote,
              ReferenceSubGroup: x?.ReferenceSubGroup,
              ParameterWith: x?.ParameterWith,
              ParameterWithName: x?.ParameterWithName,
              MergeSameValue: x?.MergeSameValue,
              BasedOnMeasurementValue: x?.BasedOnMeasurementValue,
              BasedOnHrsValue: x?.BasedOnHrsValue,
              // IsIncudeStandardRate: x?.IsIncudeStandardRate,
              AcceptanceStandard: x?.AcceptanceStandard,
              TestType: x?.TestType,
              NDTProcessType: x?.NDTProcessType,

              ListOfTestMasterImage: x?.ListOfTestMasterImage?.map((p) => ({
                TestingIDEncrypted: p?.TestingIDEncrypted,
                TestMasterImageIDEncrypted: p?.TestMasterImageIDEncrypted,
                ImageFilePath: p?.ImageFilePath,
                TestMasterIDEncrypted: p?.TestMasterIDEncrypted,
              })),
              ListOfTestingResultImages: x?.ListOfTestingResultImages?.map(
                (p) => ({
                  TestingResultImageIDEncrypted:
                    p?.TestingResultImageIDEncrypted,
                  TestingIDEncrypted: p?.TestingIDEncrypted,
                  ResultImagePath: p?.ResultImagePath,
                  Remarks: p?.Remarks,
                })
              ),

              TestingRewiseAndRectifyActionStatus:
                x?.TestingRewiseAndRectifyActionStatus,
              TPIList: x?.TPIList,
              AllowTesting: x?.AllowTesting,
              ListOfDefineMoreRates: x?.ListOfDefineMoreRates,
              UTDetails: x?.UTDetails,
              RTDetails: x?.RTDetails,
              PTDetails: x?.PTDetails,
              MTDetails: x?.MTDetails,
            }))
          );
          formikApproval.setFieldValue(
            "ListOfLetterRefDoc",
            response?.ListOfLetterRefDoc?.map((x) => ({
              InwardLetterRefImageIDEncrypted:
                x?.InwardLetterRefImageIDEncrypted,
              InwardIDEncrypted: x?.InwardIDEncrypted,
              LetterRefImageFilePath: x?.LetterRefImageFilePath,
              LetterRefImageFileName: x?.LetterRefImageFileName,
            }))
          );
          formikApproval.setFieldValue(
            "IsTPIRequired",
            response?.IsTPIRequired
          );
          formikApproval.setFieldValue(
            "IsMaterialReturnable",
            response?.IsMaterialReturnable
          );
          formikApproval.setFieldValue("IsHold", response?.IsHold);
          setShowTestingNDTApprovalModal(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (InwardMaterialID) {
      getTCDetailForTestingApproval(InwardMaterialID);
    }
  }, [InwardMaterialID]);

  const ApproveRejectTest = async (btnStatus, testIndex) => {
    if (
      btnStatus == 5 &&
      (!ListOfMaterialTests[testIndex]?.ApprovalNote ||
        ListOfMaterialTests[testIndex]?.ApprovalNote?.trim()?.length == 0)
    ) {
      return;
    } else {
      setIsLoading(true);

      let payload = {
        TestingIDEncrypted: ListOfMaterialTests[testIndex]?.TestingIDEncrypted,
        InwardMaterialIDEncrypted: InwardMaterialIDEncrypted,
        StatusRemarks: ListOfMaterialTests[testIndex]?.ApprovalNote?.trim(),
        TestingApprovalType: 1, //test wise
        TestingStatus: btnStatus,
        CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
      };

      await post(POST_TestingsApprovalInsert, payload)
        .then((response) => {
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              formikApproval.setFieldValue(
                `ListOfMaterialTests[${testIndex}].TestingStatus`,
                btnStatus
              );
              fnCallback();
            }, 500);
          } else {
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const ApproveRejectTCAllTest = async (btnStatus) => {
    if (
      btnStatus == 5 &&
      (!ApprovalNoteForApproveAll ||
        ApprovalNoteForApproveAll?.trim()?.length == 0)
    ) {
      formikApproval.setFieldError(
        "ApprovalNoteForApproveAll",
        "Approval Note is required!"
      );
      formikApproval.setFieldTouched("ApprovalNoteForApproveAll", true);
      return;
    } else {
      setIsLoading(true);

      let payload = {
        TestingIDEncrypted: "",
        InwardMaterialIDEncrypted: InwardMaterialIDEncrypted,
        StatusRemarks: ApprovalNoteForApproveAll?.trim(),
        TestingApprovalType: 2, //all test
        TestingStatus: btnStatus,
        CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
      };

      await post(POST_TestingsApprovalInsert, payload)
        .then((response) => {
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              setShowTCAllTestApprovalModal(false);
              setShowTestingNDTApprovalModal(false);
              formikApproval.setFieldValue("ApprovalNoteForApproveAll", "");
              fnCallback();
            }, 500);
          } else {
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  // const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
  //   useState(false);

  // const validationSchemaDefineMoreRates = Yup.object().shape({});

  // const formikDefineMoreRates = useFormik({
  //   validationSchema: validationSchemaDefineMoreRates,
  //   onSubmit: (values, formikHelpers) =>
  //     handleValidSubmitDefineMoreRates(values, formikHelpers),
  //   initialValues: {
  //     MoreTestRatesList: [],
  //   },
  //   validateOnBlur: false,
  // });

  // const {
  //   values: { MoreTestRatesList },
  // } = formikDefineMoreRates;

  // const handleValidSubmitDefineMoreRates = (values) => {
  //   setShowDefineMoreRatesModal(false);
  // };

  return (
    <>
      <Modal
        className="fade"
        show={showTestingNDTApprovalModal}
        onHide={setShowTestingNDTApprovalModal}
        size={"xl"}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Testing NDT Approval</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTestingNDTApprovalModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <FormikProvider value={formikApproval}>
              <Form onSubmit={formikApproval.handleSubmit}>
                <Row>
                  <Col lg={5}>
                    {ListOfMaterialTests?.filter((x) => x?.TestingStatus == 3)
                      ?.length > 0 && (
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-2"
                        title="Approve All"
                        onClick={() => setShowTCAllTestApprovalModal(true)}
                      >
                        {SVGICON.Verified}
                      </Link>
                    )}
                    <label className="mb-1">TC No:</label> &nbsp; {ApprovalTCNo}
                  </Col>
                  <Col lg={4}>
                    <label className="mb-1">Inward No:</label> &nbsp;{" "}
                    {ApprovalInwardNo} | {InwardDate}
                  </Col>
                  <Col lg={3}>
                    <label className="mb-1">EDD:</label> &nbsp; {EDD}
                  </Col>

                  <Col lg={12}>
                    <label className="mb-1">
                      Sample Detail (Job Description):
                    </label>{" "}
                    &nbsp; {SampleDetail}
                  </Col>
                  <Col lg={5}>
                    <label className="mb-1">Size:</label> &nbsp; {Size}
                  </Col>
                  <Col lg={7}>
                    <label className="mb-1">Condition:</label> &nbsp;{" "}
                    {Condition}
                  </Col>
                  <Col lg={5}>
                    <label className="mb-1">Letter Ref No:</label> &nbsp;{" "}
                    {LetterRefNo} &nbsp;{" "}
                    {ListOfLetterRefDoc?.length > 0 ? (
                      <Link
                        to="#"
                        title="Letter Ref Doc"
                        className="text-primary"
                        onClick={() => {
                          setShowLetterRefDocModal(true);
                        }}
                      >
                        View File
                      </Link>
                    ) : (
                      ""
                    )}
                  </Col>
                  {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                    <Col lg={4}>
                      <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1 me-1 mb-1">
                        <label className="mb-1">Sample Returnable:</label>{" "}
                        &nbsp; {IsMaterialReturnable == true ? "Yes" : "No"}
                      </text>
                    </Col>
                  ) : (
                    ""
                  )}

                  <Col lg={3}>
                    <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1 me-1 mb-1">
                      <label className="mb-1">TPI Required:</label> &nbsp;{" "}
                      {IsTPIRequired == true ? "Yes" : "No"}
                    </text>
                  </Col>
                  <Col lg={5}>
                    <label className="mb-1">Die No:</label> &nbsp; {DieNo}
                  </Col>
                  <Col lg={4}>
                    <label className="mb-1">Heat No:</label> &nbsp; {HeatNo}
                  </Col>
                  <Col lg={3}>
                    <label className="mb-1">DRG No:</label> &nbsp; {DRGNo}
                  </Col>
                  <Col lg={5}>
                    <label className="mb-1">Thickness:</label> &nbsp; {Thikness}
                  </Col>
                  <Col lg={4}>
                    <label className="mb-1">Area to Be Covered:</label> &nbsp;
                    {AreatoBeCovered}
                  </Col>
                  <Col lg={3}>
                    <label className="mb-1">Radiation Energy:</label> &nbsp;
                    {RadiationEnergy}
                  </Col>
                  <Col lg={5}>
                    <label className="mb-1">Material:</label> &nbsp;{" "}
                    {MaterialName}
                  </Col>
                  <Col lg={4}>
                    <label className="mb-1">Density:</label> &nbsp; {Density}
                  </Col>
                  <Col lg={3}>
                    <label className="mb-1">Sensitivity:</label> &nbsp;
                    {Sensitivity}
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Accordion className="accordion accordion-solid-bg">
                  {ListOfMaterialTests?.map((test, tIndex) => (
                    <Accordion.Item
                      className="accordion-item"
                      key={tIndex}
                      eventKey={tIndex}
                    >
                      <Accordion.Header
                        className="accordion-header rounded-lg"
                        style={{
                          backgroundColor:
                            test.TestingStatus == 1
                              ? "#ed7c79"
                              : test.TestingStatus == 2
                              ? "#80c9ff"
                              : test.TestingStatus == 3
                              ? "#4aa493"
                              : test.TestingStatus == 4
                              ? "#419841"
                              : test.TestingStatus == 5
                              ? "#f79f50"
                              : "",
                          color: "#fff",
                        }}
                      >
                        {test.TestName}
                      </Accordion.Header>
                      <Accordion.Collapse eventKey={tIndex}>
                        <div className="accordion-body">
                          <Row>
                            <Col lg={5}>
                              <label>Test Name:</label> &nbsp; {test.TestName}
                            </Col>
                            {test.TestingStatus != 1 &&
                              test.TestingStatus != 2 && (
                                <>
                                  <Col lg={4}>
                                    <label>Test Date:</label> &nbsp;{" "}
                                    {test.TestingDate == test.TestingToDate
                                      ? test.TestingDate
                                      : test.TestingDate +
                                        " to " +
                                        test.TestingToDate}
                                  </Col>

                                  <Col lg={5}>
                                    <label>Department:</label> &nbsp;{" "}
                                    {test.DepartmentName}
                                  </Col>
                                  <Col lg={4}>
                                    <label className="mb-1">
                                      Material Group:
                                    </label>{" "}
                                    &nbsp; {test.MaterialGroupName}
                                  </Col>
                                  <Col lg={3}>
                                    <label className="mb-1">
                                      Material Type:
                                    </label>{" "}
                                    &nbsp; {test.MaterialType}
                                  </Col>

                                  <Col lg={5}>
                                    <label>Reference Standard:</label> &nbsp;{" "}
                                    {test.ReferenceStandardName}
                                  </Col>
                                  {/* <Col lg={4}>
                                    <label>Machine:</label> &nbsp;{" "}
                                    {test.MachineName}
                                  </Col> */}
                                  <Col lg={3}>
                                    <label>Location:</label> &nbsp;
                                    {test.LocationTypeName}
                                  </Col>

                                  <Col lg={5}>
                                    <label>Test Master Image:</label> &nbsp;{" "}
                                    {test.ListOfTestMasterImage?.length > 0 ? (
                                      <Link
                                        to="#"
                                        className="text-primary"
                                        onClick={() => {
                                          setListTestMasterImages("");
                                          setShowTestMasterImagesModal(true);
                                          setListTestMasterImages(
                                            test.ListOfTestMasterImage
                                          );
                                        }}
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                  <Col lg={4}>
                                    <label>Testing Result Image:</label> &nbsp;{" "}
                                    {test?.ListOfTestingResultImages?.length >
                                    0 ? (
                                      <Link
                                        to="#"
                                        className="text-primary"
                                        onClick={() => {
                                          setListOfTestingResultImages("");
                                          setShowTestingResultImagesModal(true);
                                          setListOfTestingResultImages(
                                            test.ListOfTestingResultImages
                                          );
                                        }}
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                  <Col lg={3}>
                                    {IsTPIRequired == true && (
                                      <>
                                        <label>TPI Details:</label> &nbsp;{" "}
                                        {test?.TPIList?.length > 0 ? (
                                          <Link
                                            to="#"
                                            className="text-primary"
                                            onClick={() => {
                                              setListOfTPIDetails(test.TPIList);
                                              setShowTPIDetailModal(true);
                                            }}
                                          >
                                            View
                                          </Link>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    )}
                                  </Col>
                                  <Col lg={5}>
                                    <label>Tested By:</label> &nbsp;{" "}
                                    {test.TestedByEmployeeNames}
                                  </Col>
                                  <Col lg={4}>
                                    <label>Acceptance Standard:</label> &nbsp;{" "}
                                    {test.AcceptanceStandard}
                                  </Col>

                                  <Col lg={12}>
                                    <label>Result:</label> &nbsp; {test.Result}
                                  </Col>
                                  <Col lg={12}>
                                    <label>Remarks:</label> &nbsp;{" "}
                                    {test.Remarks}
                                  </Col>
                                </>
                              )}
                            {test.TestingStatus != 3 && (
                              <>
                                <Col lg={6}>
                                  <label>Testing Status:</label> &nbsp;
                                  <b>
                                    {test.TestingStatus == 1
                                      ? "Pending"
                                      : test.TestingStatus == 2
                                      ? "Draft"
                                      : test.TestingStatus == 4
                                      ? "Approved"
                                      : test.TestingStatus == 5
                                      ? "Revise & Rectify"
                                      : ""}
                                  </b>
                                </Col>
                                <Col lg={6}>
                                  {test.ApprovalNote ? (
                                    <>
                                      <label>Approval Note:</label>&nbsp;
                                      {test.ApprovalNote}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Col>
                              </>
                            )}
                          </Row>
                          <hr className="mt-0 mb-2"></hr>
                          {(test.TestingStatus == 3 ||
                            (test.TestingStatus == 4 &&
                              test.TestingRewiseAndRectifyActionStatus ==
                                true)) && (
                            <>
                              <Row>
                                <Col lg={6}>
                                  <Field
                                    type="text"
                                    name={`ListOfMaterialTests[${tIndex}].ApprovalNote`}
                                    component={CustomInput}
                                    placeholder="Approval Note"
                                    maxLength={100}
                                    required={test.btnStatus == 5} //required when Revise & Rectify
                                  />
                                  {test.btnStatus == 5 &&
                                    (!test?.ApprovalNote ||
                                      test?.ApprovalNote?.trim().length ==
                                        0) && (
                                      <div
                                        className="invalid-feedback animated fadeInUp"
                                        style={{
                                          display: "block",
                                          marginTop: "-10px",
                                        }}
                                      >
                                        Approval Note is required!
                                      </div>
                                    )}
                                </Col>
                                <Col lg={6}>
                                  {test.TestingStatus == 3 && (
                                    <button
                                      type="button"
                                      // className="btn btn-primary"
                                      className="btn btn-primary btn-sm me-2"
                                      onClick={() => {
                                        formikApproval.setFieldValue(
                                          `ListOfMaterialTests[${tIndex}].btnStatus`,
                                          4
                                        );
                                        ApproveRejectTest(4, tIndex);
                                      }}
                                    >
                                      <i className="fa fa-circle-check"></i>{" "}
                                      Approve
                                    </button>
                                  )}
                                  <button
                                    type="button"
                                    // className="btn btn-danger light"
                                    className="btn btn-primary btn-sm"
                                    onClick={(e) => {
                                      formikApproval.setFieldValue(
                                        `ListOfMaterialTests[${tIndex}].btnStatus`,
                                        5
                                      );
                                      ApproveRejectTest(5, tIndex);
                                    }}
                                  >
                                    <i className="fa fa-rotate-left"></i> Revise
                                    & Rectify
                                  </button>
                                  {(AuthUser?.UserType !== 1 ||
                                    formsList?.filter(
                                      (x) =>
                                        x?.FormID == 33 &&
                                        (x?.IsAdd || x?.IsEdit)
                                    )?.length > 0) && (
                                    <Link
                                      to={
                                        test?.AllowTesting == true &&
                                        IsHold == false
                                          ? `/testing${
                                              IsNDT ? "-ndt" : ""
                                            }/${window.btoa(
                                              test.InwardMaterialIDEncrypted
                                            )}/${window.btoa(
                                              test.InwardMaterialTestDetailIDEncrypted
                                            )}`
                                          : "#"
                                      }
                                      className="btn btn-primary btn-sm ms-2"
                                      title="Edit"
                                      style={{
                                        cursor:
                                          test?.AllowTesting == true &&
                                          IsHold == false
                                            ? "pointer"
                                            : "not-allowed",
                                      }}
                                    >
                                      <i className="fa fa-pencil"></i> Edit
                                    </Link>
                                  )}
                                </Col>
                              </Row>
                              <hr className="mt-0 mb-1"></hr>
                            </>
                          )}
                          {test.TestingStatus != 1 &&
                            test.TestingStatus != 2 && (
                              <>
                                <Row>
                                  <div className="d-flex justify-content-between mb-0">
                                    <div className="d-flex mb-0">
                                      <label>Testing Detail</label>
                                    </div>
                                  </div>
                                  <Col lg={12}>
                                    <div
                                      className="card mb-0"
                                      style={{ height: "auto" }}
                                    >
                                      <div className="card-body p-2">
                                        {test?.NDTProcessType == 1 ? (
                                          <>
                                            <Row>
                                              <Col lg={5}>
                                                <label>Job Type:</label> &nbsp;
                                                {test?.UTDetails[0].JobType}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Job Description:</label>
                                                &nbsp;
                                                {
                                                  test?.UTDetails[0]
                                                    .JobDescripation
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Procedure:</label> &nbsp;
                                                {
                                                  test?.UTDetails[0]
                                                    .ProcedureName
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>
                                                  Surface Condition:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.UTDetails[0]
                                                    .SurfaceCondition
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Additions To Deviations:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.UTDetails[0]
                                                    .AdditionsToDeviationsName
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>
                                                  Extent Of Examination:
                                                </label>
                                                &nbsp;
                                                {test?.UTDetails[0].ExtentOfExa}
                                              </Col>
                                              <Col lg={5}>
                                                <label>
                                                  Stage Of Examination:
                                                </label>
                                                &nbsp;
                                                {test?.UTDetails[0].StageOfExa}
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Surface Temprature:
                                                </label>
                                                &nbsp;
                                                {test?.UTDetails[0].SurfaceTemp}
                                              </Col>
                                              <Col lg={3}>
                                                <label>Couplant:</label>
                                                &nbsp;
                                                {test?.UTDetails[0].Couplant}
                                              </Col>
                                              <Col lg={5}>
                                                <label>Method:</label>
                                                &nbsp;
                                                {test?.UTDetails[0].Method}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Welding Process:</label>
                                                &nbsp;
                                                {
                                                  test?.UTDetails[0]
                                                    .WeldingProcess
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>
                                                  Basic Cali. Block:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.UTDetails[0]
                                                    .BasicCaliBlock
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>Ref. Sensitivity:</label>
                                                &nbsp;
                                                {
                                                  test?.UTDetails[0]
                                                    .RefSensitivity
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Test Carried Out at:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.UTDetails[0]
                                                    .TestCarriedOutat
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Worksheet No:</label>
                                                &nbsp;
                                                {test?.UTDetails[0].WorksheetNo}
                                              </Col>
                                            </Row>
                                            <hr className="mt-0 mb-1"></hr>
                                            <Row>
                                              <Col lg={12}>
                                                <div className="p-2 pt-0">
                                                  <div className="default-tab">
                                                    <Tab.Container
                                                      defaultActiveKey={
                                                        "detail"
                                                      }
                                                    >
                                                      <Nav
                                                        as="ul"
                                                        className="nav-tabs"
                                                      >
                                                        {ListOfUT?.length > 0
                                                          ? ListOfUT?.map(
                                                              (x, i) => (
                                                                <Nav.Item
                                                                  as="li"
                                                                  key={i}
                                                                >
                                                                  <Nav.Link
                                                                    eventKey={
                                                                      x?.FormNo ==
                                                                      1
                                                                        ? "detail"
                                                                        : x?.FormNo ==
                                                                          2
                                                                        ? "equipment"
                                                                        : x?.FormNo ==
                                                                          3
                                                                        ? "probe"
                                                                        : ""
                                                                    }
                                                                  >
                                                                    {x?.FormNo ==
                                                                    1 ? (
                                                                      <i className="la la-comment me-2" />
                                                                    ) : x?.FormNo ==
                                                                      2 ? (
                                                                      <i className="la la-user-cog me-2"></i>
                                                                    ) : x?.FormNo ==
                                                                      3 ? (
                                                                      <i className="la la-cogs me-2"></i>
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                    {x?.label}
                                                                  </Nav.Link>
                                                                </Nav.Item>
                                                              )
                                                            )
                                                          : ""}
                                                      </Nav>
                                                      <Tab.Content className="pt-2">
                                                        {ListOfUT?.length > 0
                                                          ? ListOfUT?.map(
                                                              (item, index) => (
                                                                <Tab.Pane
                                                                  eventKey={
                                                                    item?.FormNo ==
                                                                    1
                                                                      ? "detail"
                                                                      : item?.FormNo ==
                                                                        2
                                                                      ? "equipment"
                                                                      : item?.FormNo ==
                                                                        3
                                                                      ? "probe"
                                                                      : ""
                                                                  }
                                                                  key={index}
                                                                >
                                                                  <div
                                                                    className="card mb-2"
                                                                    style={{
                                                                      height:
                                                                        "auto",
                                                                    }}
                                                                  >
                                                                    <div className="card-body p-2">
                                                                      <Row>
                                                                        <Col
                                                                          lg={
                                                                            12
                                                                          }
                                                                        >
                                                                          <div className="table-responsive active-projects style-1 shorting mb-2">
                                                                            <div
                                                                              id="ParameterDetail-tbl_wrapper"
                                                                              className="dataTables_wrapper table-responsive no-footer"
                                                                            >
                                                                              {index ==
                                                                              0 ? (
                                                                                <table
                                                                                  id="ParameterDetail-tbl"
                                                                                  className="table table-bordered no-footer mb-0"
                                                                                >
                                                                                  <thead>
                                                                                    <tr>
                                                                                      <th width="2%">
                                                                                        Sr.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Ch.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Ch.
                                                                                        Date
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Offer
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Offer
                                                                                        Date
                                                                                      </th>
                                                                                      <th width="10%">
                                                                                        {test
                                                                                          ?.UTDetails[0]
                                                                                          .JobDescripationLabel
                                                                                          ? test
                                                                                              ?.UTDetails[0]
                                                                                              .JobDescripationLabel
                                                                                          : "Job Description"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        {test
                                                                                          ?.UTDetails[0]
                                                                                          .UTNoLabel
                                                                                          ? test
                                                                                              ?.UTDetails[0]
                                                                                              .UTNoLabel
                                                                                          : "Tested Area"}
                                                                                      </th>
                                                                                      <th
                                                                                        width="8%"
                                                                                        style={{
                                                                                          textTransform:
                                                                                            "none",
                                                                                        }}
                                                                                      >
                                                                                        {test
                                                                                          ?.UTDetails[0]
                                                                                          .HeatNoLabel
                                                                                          ? test
                                                                                              ?.UTDetails[0]
                                                                                              .HeatNoLabel
                                                                                          : "Size(mm)"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        {test
                                                                                          ?.UTDetails[0]
                                                                                          .JointNoLabel
                                                                                          ? test
                                                                                              ?.UTDetails[0]
                                                                                              .JointNoLabel
                                                                                          : "Joint No"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        {test
                                                                                          ?.UTDetails[0]
                                                                                          .QtyLabel
                                                                                          ? test
                                                                                              ?.UTDetails[0]
                                                                                              .QtyLabel
                                                                                          : "Quantity"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Observation
                                                                                      </th>
                                                                                      <th
                                                                                        width="8%"
                                                                                        style={{
                                                                                          textAlign:
                                                                                            "left",
                                                                                        }}
                                                                                      >
                                                                                        Result
                                                                                      </th>
                                                                                    </tr>
                                                                                  </thead>
                                                                                  <tbody>
                                                                                    {test
                                                                                      ?.UTDetails[0]
                                                                                      ?.ListOfTestingUTDetail
                                                                                      ?.length >
                                                                                    0 ? (
                                                                                      test?.UTDetails[0]?.ListOfTestingUTDetail?.map(
                                                                                        (
                                                                                          x,
                                                                                          indx
                                                                                        ) => (
                                                                                          <tr>
                                                                                            <td
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {indx +
                                                                                                1}
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.ChallanNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.ChallanDate
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.OfferNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.OfferDate
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.JobDescripation
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.UTNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.HeatNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.JointNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.Quantity
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.Observation
                                                                                              }
                                                                                            </td>
                                                                                            <td
                                                                                              className="p-1"
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "left",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                x.Result
                                                                                              }
                                                                                            </td>
                                                                                          </tr>
                                                                                        )
                                                                                      )
                                                                                    ) : (
                                                                                      <tr>
                                                                                        <td
                                                                                          colSpan={
                                                                                            13
                                                                                          }
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                        >
                                                                                          <div>
                                                                                            {
                                                                                              "No Record Found..."
                                                                                            }
                                                                                          </div>
                                                                                        </td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </tbody>
                                                                                </table>
                                                                              ) : index ==
                                                                                1 ? (
                                                                                <table
                                                                                  id="EquipmentDetail-tbl"
                                                                                  className="table table-bordered no-footer mb-0"
                                                                                >
                                                                                  <thead>
                                                                                    <tr>
                                                                                      <th width="2%">
                                                                                        Sr.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="20%">
                                                                                        Equipment
                                                                                      </th>
                                                                                      <th width="20%">
                                                                                        Make
                                                                                      </th>
                                                                                      <th width="15%">
                                                                                        Serial
                                                                                        No
                                                                                      </th>
                                                                                      <th
                                                                                        width="15%"
                                                                                        style={{
                                                                                          textAlign:
                                                                                            "left",
                                                                                        }}
                                                                                      >
                                                                                        Cali.
                                                                                        Due
                                                                                        Date
                                                                                      </th>
                                                                                    </tr>
                                                                                  </thead>
                                                                                  <tbody>
                                                                                    {test
                                                                                      ?.UTDetails[0]
                                                                                      ?.ListOfTestingUTEquipmentDetail
                                                                                      ?.length >
                                                                                    0 ? (
                                                                                      test?.UTDetails[0]?.ListOfTestingUTEquipmentDetail?.map(
                                                                                        (
                                                                                          itemTest,
                                                                                          indx
                                                                                        ) => (
                                                                                          <tr
                                                                                            key={
                                                                                              indx
                                                                                            }
                                                                                          >
                                                                                            <td
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {indx +
                                                                                                1}
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.EquipmentName
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.Make
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.SerialNo
                                                                                              }
                                                                                            </td>
                                                                                            <td
                                                                                              className="p-1"
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "left",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                itemTest.CalibrationDueDate
                                                                                              }
                                                                                            </td>
                                                                                          </tr>
                                                                                        )
                                                                                      )
                                                                                    ) : (
                                                                                      <tr>
                                                                                        <td
                                                                                          colSpan={
                                                                                            13
                                                                                          }
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                        >
                                                                                          <div>
                                                                                            {
                                                                                              "No Record Found..."
                                                                                            }
                                                                                          </div>
                                                                                        </td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </tbody>
                                                                                </table>
                                                                              ) : index ==
                                                                                2 ? (
                                                                                <table
                                                                                  id="ProbeDetail-tbl"
                                                                                  className="table table-bordered no-footer mb-0"
                                                                                >
                                                                                  <thead>
                                                                                    <tr>
                                                                                      <th width="2%">
                                                                                        Sr.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="15%">
                                                                                        Type
                                                                                        Of
                                                                                        Probe
                                                                                      </th>
                                                                                      <th width="10%">
                                                                                        Size
                                                                                        Of
                                                                                        Probe
                                                                                      </th>
                                                                                      <th width="13%">
                                                                                        Refraction
                                                                                        Angle
                                                                                      </th>
                                                                                      <th width="13%">
                                                                                        Frequency
                                                                                      </th>
                                                                                      <th width="10%">
                                                                                        Serial
                                                                                        No
                                                                                      </th>
                                                                                      <th width="15%">
                                                                                        Remark
                                                                                      </th>
                                                                                      <th width="15%">
                                                                                        Ref.
                                                                                        Gain
                                                                                      </th>
                                                                                      <th width="15%">
                                                                                        Scanning
                                                                                        Gain
                                                                                      </th>
                                                                                      <th
                                                                                        width="15%"
                                                                                        style={{
                                                                                          textAlign:
                                                                                            "left",
                                                                                        }}
                                                                                      >
                                                                                        Cali.
                                                                                        Range
                                                                                      </th>
                                                                                    </tr>
                                                                                  </thead>
                                                                                  <tbody>
                                                                                    {test
                                                                                      ?.UTDetails[0]
                                                                                      ?.ListOfTestingUTProbDetail
                                                                                      ?.length >
                                                                                    0 ? (
                                                                                      test?.UTDetails[0]?.ListOfTestingUTProbDetail?.map(
                                                                                        (
                                                                                          x,
                                                                                          ind
                                                                                        ) => (
                                                                                          <tr
                                                                                            key={
                                                                                              ind
                                                                                            }
                                                                                          >
                                                                                            <td
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {ind +
                                                                                                1}
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.TypeOfProbe
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.SizeOfProbe
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.RefractionAngle
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.Frequency
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.SerialNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.Remark
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.RefGain
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                x.ScanningGain
                                                                                              }
                                                                                            </td>
                                                                                            <td
                                                                                              className="p-1"
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "left",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                x.CalibrationRange
                                                                                              }
                                                                                            </td>
                                                                                          </tr>
                                                                                        )
                                                                                      )
                                                                                    ) : (
                                                                                      <tr>
                                                                                        <td
                                                                                          colSpan={
                                                                                            13
                                                                                          }
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                        >
                                                                                          <div>
                                                                                            {
                                                                                              "No Record Found..."
                                                                                            }
                                                                                          </div>
                                                                                        </td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </tbody>
                                                                                </table>
                                                                              ) : (
                                                                                ""
                                                                              )}
                                                                            </div>
                                                                          </div>
                                                                        </Col>
                                                                      </Row>
                                                                    </div>
                                                                  </div>
                                                                </Tab.Pane>
                                                              )
                                                            )
                                                          : ""}
                                                      </Tab.Content>
                                                    </Tab.Container>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </>
                                        ) : test?.NDTProcessType == 2 ? (
                                          <>
                                            <Row>
                                              <Col lg={5}>
                                                <label>
                                                  Test Carried Out at:
                                                </label>{" "}
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .TestCarriedOutat
                                                }
                                              </Col>

                                              <Col lg={4}>
                                                <label>Technique:</label> &nbsp;
                                                {test?.RTDetails[0].Technique}
                                              </Col>
                                              <Col lg={3}>
                                                <label>RT Coverage:</label>
                                                &nbsp;
                                                {test?.RTDetails[0].RTCoverage}
                                              </Col>
                                              <Col lg={5}>
                                                <label>
                                                  Lead Thickness(Back):
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .LeadThiknessBack
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Additions To Deviations:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .AdditionsToDeviationsName
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Welding Process:</label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .WeldingProcess
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>
                                                  Lead Thickness(Front):
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .LeadThiknessFront
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>Camera:</label>
                                                &nbsp;
                                                {test?.RTDetails[0].CameraName}
                                              </Col>
                                              <Col lg={3}>
                                                <label>Source Strength:</label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .SourceStrength
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>Source Size:</label>
                                                &nbsp;
                                                {test?.RTDetails[0].SourceSize}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Rediation Source:</label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .RediationSource
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Exposure Time:</label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .ExposureTime
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>Film Brand:</label>
                                                &nbsp;
                                                {test?.RTDetails[0].FilmBrand}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Viewing:</label>
                                                &nbsp;
                                                {test?.RTDetails[0].Viewing}
                                              </Col>
                                              <Col lg={3}>
                                                <label>Procedure:</label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .ProcedureName
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>X-Ray KV:</label>
                                                &nbsp;
                                                {test?.RTDetails[0].XRayKV}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Processing Time:</label>
                                                &nbsp;
                                                {
                                                  test?.RTDetails[0]
                                                    .ProcessingTime
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Screen:</label>
                                                &nbsp;
                                                {test?.RTDetails[0].Screen}
                                              </Col>
                                            </Row>
                                            <hr className="mt-0 mb-1"></hr>
                                            <Row>
                                              <Col lg={12}>
                                                <div className="table-responsive active-projects style-1 shorting mb-2">
                                                  <div
                                                    id="ParameterDetail-tbl_wrapper"
                                                    className="dataTables_wrapper table-responsive no-footer"
                                                  >
                                                    <table
                                                      id="ParameterDetail-tbl"
                                                      className="table table-bordered no-footer mb-0"
                                                    >
                                                      <thead>
                                                        <tr>
                                                          <th width="2%">
                                                            Sr. No
                                                          </th>
                                                          <th width="10%">
                                                            Identification
                                                          </th>
                                                          <th width="10%">
                                                            Thickness
                                                          </th>
                                                          <th width="8%">
                                                            SFD(Inch)
                                                          </th>
                                                          <th width="8%">
                                                            IQI
                                                          </th>
                                                          <th width="8%">
                                                            Density
                                                          </th>
                                                          <th width="8%">
                                                            Essential Wire
                                                          </th>
                                                          <th width="8%">
                                                            Film Size
                                                          </th>
                                                          <th width="8%">
                                                            Location
                                                          </th>
                                                          <th width="8%">
                                                            Findings
                                                          </th>
                                                          <th width="8%">
                                                            Result
                                                          </th>
                                                          <th width="3%">
                                                            Inv.
                                                          </th>
                                                          <th
                                                            width="8%"
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            Film Qty
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {test?.RTDetails[0]
                                                          ?.ListOfTestingRTDetail
                                                          ?.length > 0 ? (
                                                          test?.RTDetails[0]?.ListOfTestingRTDetail?.map(
                                                            (item, indx) => (
                                                              <tr key={indx}>
                                                                <td
                                                                  style={{
                                                                    textAlign:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  {indx + 1}
                                                                </td>
                                                                <td>
                                                                  {
                                                                    item.Identification
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {
                                                                    item.Thickness
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {item.SFD}
                                                                </td>
                                                                <td>
                                                                  {item.IQI}
                                                                </td>
                                                                <td>
                                                                  {item.Density}
                                                                </td>
                                                                <td>
                                                                  {
                                                                    item.EssentialWire
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {
                                                                    item.FilmSize
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {
                                                                    item.Location
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {
                                                                    item.FindingsName
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {item.Result}
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    textAlign:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  {item.Inv
                                                                    ? "Yes"
                                                                    : "No"}
                                                                </td>
                                                                <td
                                                                  className="p-1"
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                  }}
                                                                >
                                                                  {item.FilmQty}
                                                                </td>
                                                              </tr>
                                                            )
                                                          )
                                                        ) : (
                                                          <tr>
                                                            <td
                                                              colSpan={13}
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <div>
                                                                {
                                                                  "No Record Found..."
                                                                }
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </>
                                        ) : test?.NDTProcessType == 3 ? (
                                          <>
                                            <Row>
                                              <Col lg={5}>
                                                <label>Job Type:</label> &nbsp;
                                                {test?.MTDetails[0].JobType}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Job Description:</label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .JobDescripation
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Procedure:</label> &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .ProcedureName
                                                }
                                              </Col>

                                              <Col lg={5}>
                                                <label>
                                                  Surface Condition:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .SurfaceCondition
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Additions To Deviations:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .AdditionsToDeviationsName
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>
                                                  Extent Of Examination:
                                                </label>
                                                &nbsp;
                                                {test?.MTDetails[0].ExtentOfExa}
                                              </Col>

                                              <Col lg={5}>
                                                <label>
                                                  Stage Of Examination:
                                                </label>
                                                &nbsp;
                                                {test?.MTDetails[0].StageOfExa}
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Surface Temprature:
                                                </label>
                                                &nbsp;
                                                {test?.MTDetails[0].SurfaceTemp}
                                              </Col>
                                              <Col lg={3}>
                                                <label>Couplant:</label>
                                                &nbsp;
                                                {test?.MTDetails[0].Couplant}
                                              </Col>

                                              <Col lg={5}>
                                                <label>Method:</label>
                                                &nbsp;
                                                {test?.MTDetails[0].Method}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Welding Process:</label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .WeldingProcess
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Magnetization:</label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .Magnetization
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>
                                                  Magnetization Current:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .MagnetizationCurrent
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Test Carried Out at:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .TestCarriedOutat
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Worksheet No:</label>
                                                &nbsp;
                                                {test?.MTDetails[0].WorksheetNo}
                                              </Col>
                                              <Col lg={5}>
                                                <label>Field Indicator:</label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .FieldIndicator
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Measured Lifting Force:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .MeaLiftingForce
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Background Point:</label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .BackgroundPoint
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>
                                                  Pole/Prod Spacing:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .PoleProdSpacing
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>Light Intensity:</label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .LightIntensity
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Inspection Light:</label>
                                                &nbsp;
                                                {
                                                  test?.MTDetails[0]
                                                    .InspectionLight
                                                }
                                              </Col>
                                            </Row>
                                            <hr className="mt-0 mb-1"></hr>
                                            <Row>
                                              <Col lg={12}>
                                                <div className="p-2 pt-0">
                                                  <div className="default-tab">
                                                    <Tab.Container
                                                      defaultActiveKey={
                                                        "detail"
                                                      }
                                                    >
                                                      <Nav
                                                        as="ul"
                                                        className="nav-tabs"
                                                      >
                                                        {ListOfFormsMT?.length >
                                                        0
                                                          ? ListOfFormsMT?.map(
                                                              (item, index) => (
                                                                <Nav.Item
                                                                  as="li"
                                                                  key={index}
                                                                >
                                                                  <Nav.Link
                                                                    eventKey={
                                                                      item?.FormNo ==
                                                                      1
                                                                        ? "detail"
                                                                        : item?.FormNo ==
                                                                          2
                                                                        ? "equipment"
                                                                        : item?.FormNo ==
                                                                          3
                                                                        ? "material"
                                                                        : ""
                                                                    }
                                                                  >
                                                                    {item?.FormNo ==
                                                                    1 ? (
                                                                      <i className="la la-comment me-2" />
                                                                    ) : item?.FormNo ==
                                                                      2 ? (
                                                                      <i className="la la-user-cog me-2"></i>
                                                                    ) : item?.FormNo ==
                                                                      3 ? (
                                                                      <i className="la la-cogs me-2"></i>
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                    {
                                                                      item?.label
                                                                    }
                                                                  </Nav.Link>
                                                                </Nav.Item>
                                                              )
                                                            )
                                                          : ""}
                                                      </Nav>
                                                      <Tab.Content className="pt-2">
                                                        {ListOfFormsMT?.length >
                                                        0
                                                          ? ListOfFormsMT?.map(
                                                              (item, index) => (
                                                                <Tab.Pane
                                                                  eventKey={
                                                                    item?.FormNo ==
                                                                    1
                                                                      ? "detail"
                                                                      : item?.FormNo ==
                                                                        2
                                                                      ? "equipment"
                                                                      : item?.FormNo ==
                                                                        3
                                                                      ? "material"
                                                                      : ""
                                                                  }
                                                                  key={index}
                                                                >
                                                                  <div
                                                                    className="card mb-2"
                                                                    style={{
                                                                      height:
                                                                        "auto",
                                                                    }}
                                                                  >
                                                                    <div className="card-body p-2">
                                                                      <Row>
                                                                        <Col
                                                                          lg={
                                                                            12
                                                                          }
                                                                        >
                                                                          <div className="table-responsive active-projects style-1 shorting mb-2">
                                                                            <div
                                                                              id="ParameterDetail-tbl_wrapper"
                                                                              className="dataTables_wrapper table-responsive no-footer"
                                                                            >
                                                                              {index ==
                                                                              0 ? (
                                                                                <table
                                                                                  id="ParameterDetail-tbl"
                                                                                  className="table table-bordered no-footer mb-0"
                                                                                >
                                                                                  <thead>
                                                                                    <tr>
                                                                                      <th width="2%">
                                                                                        Sr.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Ch.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Ch.
                                                                                        Date
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Offer
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Offer
                                                                                        Date
                                                                                      </th>
                                                                                      <th width="10%">
                                                                                        {test
                                                                                          ?.MTDetails[0]
                                                                                          ?.JobDescripationLabel
                                                                                          ? test
                                                                                              ?.MTDetails[0]
                                                                                              ?.JobDescripationLabel
                                                                                          : "Job Description"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        {test
                                                                                          ?.MTDetails[0]
                                                                                          ?.MPTNoLabel
                                                                                          ? test
                                                                                              ?.MTDetails[0]
                                                                                              ?.MPTNoLabel
                                                                                          : "Tested Area"}
                                                                                      </th>
                                                                                      <th
                                                                                        width="8%"
                                                                                        style={{
                                                                                          textTransform:
                                                                                            "none",
                                                                                        }}
                                                                                      >
                                                                                        {test
                                                                                          ?.MTDetails[0]
                                                                                          ?.HeatNoLabel
                                                                                          ? test
                                                                                              ?.MTDetails[0]
                                                                                              ?.HeatNoLabel
                                                                                          : "Size(mm)"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        {test
                                                                                          ?.MTDetails[0]
                                                                                          ?.JointNoLabel
                                                                                          ? test
                                                                                              ?.MTDetails[0]
                                                                                              ?.JointNoLabel
                                                                                          : "Joint No"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Qty
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Observation
                                                                                      </th>
                                                                                      <th
                                                                                        width="8%"
                                                                                        style={{
                                                                                          textAlign:
                                                                                            "left",
                                                                                        }}
                                                                                      >
                                                                                        Result
                                                                                      </th>
                                                                                    </tr>
                                                                                  </thead>
                                                                                  <tbody>
                                                                                    {test
                                                                                      ?.MTDetails[0]
                                                                                      ?.ListOfTestingMTDetail
                                                                                      ?.length >
                                                                                    0 ? (
                                                                                      test?.MTDetails[0]?.ListOfTestingMTDetail?.map(
                                                                                        (
                                                                                          itemTest,
                                                                                          indxTest
                                                                                        ) => (
                                                                                          <tr
                                                                                            key={
                                                                                              indxTest
                                                                                            }
                                                                                          >
                                                                                            <td
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {indxTest +
                                                                                                1}
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.ChallanNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.ChallanDate
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.OfferNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.OfferDate
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.JobDescripation
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.MPTNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.HeatNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.JointNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.Quantity
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.Observation
                                                                                              }
                                                                                            </td>
                                                                                            <td
                                                                                              className="p-1"
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "left",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                itemTest.Result
                                                                                              }
                                                                                            </td>
                                                                                          </tr>
                                                                                        )
                                                                                      )
                                                                                    ) : (
                                                                                      <tr>
                                                                                        <td
                                                                                          colSpan={
                                                                                            13
                                                                                          }
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                        >
                                                                                          <div>
                                                                                            {
                                                                                              "No Record Found..."
                                                                                            }
                                                                                          </div>
                                                                                        </td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </tbody>
                                                                                </table>
                                                                              ) : index ==
                                                                                1 ? (
                                                                                <table
                                                                                  id="EquipmentDetail-tbl"
                                                                                  className="table table-bordered no-footer mb-0"
                                                                                >
                                                                                  <thead>
                                                                                    <tr>
                                                                                      <th width="2%">
                                                                                        Sr.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="20%">
                                                                                        Equipment
                                                                                      </th>
                                                                                      <th width="20%">
                                                                                        Make
                                                                                      </th>
                                                                                      <th width="15%">
                                                                                        Serial
                                                                                        No
                                                                                      </th>
                                                                                      <th
                                                                                        width="15%"
                                                                                        style={{
                                                                                          textAlign:
                                                                                            "left",
                                                                                        }}
                                                                                      >
                                                                                        Cali.
                                                                                        Due
                                                                                        Date
                                                                                      </th>
                                                                                    </tr>
                                                                                  </thead>
                                                                                  <tbody>
                                                                                    {test
                                                                                      ?.MTDetails[0]
                                                                                      ?.ListOfTestingMTEquipmentDetail
                                                                                      ?.length >
                                                                                    0 ? (
                                                                                      test?.MTDetails[0]?.ListOfTestingMTEquipmentDetail?.map(
                                                                                        (
                                                                                          itemTest,
                                                                                          indxTest
                                                                                        ) => (
                                                                                          <tr
                                                                                            key={
                                                                                              indxTest
                                                                                            }
                                                                                          >
                                                                                            <td
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {indxTest +
                                                                                                1}
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.EquipmentName
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.Make
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.SerialNo
                                                                                              }
                                                                                            </td>
                                                                                            <td
                                                                                              className="p-1"
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "left",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                itemTest.CalibrationDueDate
                                                                                              }
                                                                                            </td>
                                                                                          </tr>
                                                                                        )
                                                                                      )
                                                                                    ) : (
                                                                                      <tr>
                                                                                        <td
                                                                                          colSpan={
                                                                                            13
                                                                                          }
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                        >
                                                                                          <div>
                                                                                            {
                                                                                              "No Record Found..."
                                                                                            }
                                                                                          </div>
                                                                                        </td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </tbody>
                                                                                </table>
                                                                              ) : index ==
                                                                                2 ? (
                                                                                <table
                                                                                  id="MaterialDetail-tbl"
                                                                                  className="table table-bordered no-footer mb-0"
                                                                                >
                                                                                  <thead>
                                                                                    <tr>
                                                                                      <th width="2%">
                                                                                        Sr.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="15%">
                                                                                        Material
                                                                                      </th>
                                                                                      <th width="10%">
                                                                                        Manufacturer
                                                                                      </th>
                                                                                      <th width="13%">
                                                                                        Batch
                                                                                        No
                                                                                      </th>
                                                                                      <th
                                                                                        width="15%"
                                                                                        style={{
                                                                                          textAlign:
                                                                                            "left",
                                                                                        }}
                                                                                      >
                                                                                        Mfg.
                                                                                        Date
                                                                                      </th>
                                                                                    </tr>
                                                                                  </thead>
                                                                                  <tbody>
                                                                                    {test
                                                                                      ?.MTDetails[0]
                                                                                      ?.ListOfTestingMTMaterialDetail
                                                                                      ?.length >
                                                                                    0 ? (
                                                                                      test?.MTDetails[0]?.ListOfTestingMTMaterialDetail?.map(
                                                                                        (
                                                                                          itemTest,
                                                                                          indxTest
                                                                                        ) => (
                                                                                          <tr
                                                                                            key={
                                                                                              indxTest
                                                                                            }
                                                                                          >
                                                                                            <td
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {indxTest +
                                                                                                1}
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.MaterialName
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.ManufacturerOfPowder
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.BatchNo
                                                                                              }
                                                                                            </td>
                                                                                            <td
                                                                                              className="p-1"
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "left",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                itemTest.ManufacturerDate
                                                                                              }
                                                                                            </td>
                                                                                          </tr>
                                                                                        )
                                                                                      )
                                                                                    ) : (
                                                                                      <tr>
                                                                                        <td
                                                                                          colSpan={
                                                                                            5
                                                                                          }
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                        >
                                                                                          <div>
                                                                                            {
                                                                                              "No Record Found..."
                                                                                            }
                                                                                          </div>
                                                                                        </td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </tbody>
                                                                                </table>
                                                                              ) : (
                                                                                ""
                                                                              )}
                                                                            </div>
                                                                          </div>
                                                                        </Col>
                                                                      </Row>
                                                                    </div>
                                                                  </div>
                                                                </Tab.Pane>
                                                              )
                                                            )
                                                          : ""}
                                                      </Tab.Content>
                                                    </Tab.Container>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </>
                                        ) : test?.NDTProcessType == 4 ? (
                                          <>
                                            <Row>
                                              <Col lg={5}>
                                                <label>Job Type:</label> &nbsp;
                                                {test?.PTDetails[0].JobType}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Job Description:</label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .JobDescripation
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>Procedure:</label> &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .ProcedureName
                                                }
                                              </Col>

                                              <Col lg={5}>
                                                <label>
                                                  Surface Condition:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .SurfaceCondition
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Additions To Deviations:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .AdditionsToDeviationsName
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>
                                                  Extent Of Examination:
                                                </label>
                                                &nbsp;
                                                {test?.PTDetails[0].ExtentOfExa}
                                              </Col>

                                              <Col lg={5}>
                                                <label>
                                                  Stage Of Examination:
                                                </label>
                                                &nbsp;
                                                {test?.PTDetails[0].StageOfExa}
                                              </Col>
                                              <Col lg={4}>
                                                <label>
                                                  Surface Temprature:
                                                </label>
                                                &nbsp;
                                                {test?.PTDetails[0].SurfaceTemp}
                                              </Col>
                                              <Col lg={3}>
                                                <label>Pre-Cleaning:</label>
                                                &nbsp;
                                                {test?.PTDetails[0].PreCleaning}
                                              </Col>

                                              <Col lg={5}>
                                                <label>Post-Cleaning:</label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .PostCleaning
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>Method:</label>
                                                &nbsp;
                                                {test?.PTDetails[0].Method}
                                              </Col>
                                              <Col lg={3}>
                                                <label>Welding Process:</label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .WeldingProcess
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>
                                                  Penetrant Dwell Time:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .PenetrantDwellTime
                                                }
                                              </Col>
                                              <Col lg={4}>
                                                <label>Development Time:</label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .DevelopmentTime
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>
                                                  Test Carried Out at:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .TestCarriedOutat
                                                }
                                              </Col>
                                              <Col lg={5}>
                                                <label>Worksheet No:</label>
                                                &nbsp;
                                                {test?.PTDetails[0].WorksheetNo}
                                              </Col>
                                              <Col lg={4}>
                                                <label>Light Intensity:</label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .LightIntensity
                                                }
                                              </Col>
                                              <Col lg={3}>
                                                <label>
                                                  Developer Dwell Time:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .DeveloperDwellTime
                                                }
                                              </Col>
                                              <Col lg={10}>
                                                <label>
                                                  Drying Time After Removal Of
                                                  Excess Penetrant:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .DryingTimeAfterRemovalOfExcessPenetrant
                                                }
                                              </Col>
                                              <Col lg={10}>
                                                <label>
                                                  Drying Time After
                                                  Pre-Cleaning:
                                                </label>
                                                &nbsp;
                                                {
                                                  test?.PTDetails[0]
                                                    .DryingTimeAfterPreCleaning
                                                }
                                              </Col>
                                            </Row>
                                            <hr className="mt-0 mb-1"></hr>
                                            <Row>
                                              <Col lg={12}>
                                                <div className="p-2 pt-0">
                                                  <div className="default-tab">
                                                    <Tab.Container
                                                      defaultActiveKey={
                                                        "detail"
                                                      }
                                                    >
                                                      <Nav
                                                        as="ul"
                                                        className="nav-tabs"
                                                      >
                                                        {ListOfFormsPT?.length >
                                                        0
                                                          ? ListOfFormsPT?.map(
                                                              (item, index) => (
                                                                <Nav.Item
                                                                  as="li"
                                                                  key={index}
                                                                >
                                                                  <Nav.Link
                                                                    eventKey={
                                                                      item?.FormNo ==
                                                                      1
                                                                        ? "detail"
                                                                        : item?.FormNo ==
                                                                          2
                                                                        ? "material"
                                                                        : ""
                                                                    }
                                                                  >
                                                                    {item?.FormNo ==
                                                                    1 ? (
                                                                      <i className="la la-comment me-2" />
                                                                    ) : item?.FormNo ==
                                                                      2 ? (
                                                                      <i className="la la-cogs me-2"></i>
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                    {
                                                                      item?.label
                                                                    }
                                                                  </Nav.Link>
                                                                </Nav.Item>
                                                              )
                                                            )
                                                          : ""}
                                                      </Nav>
                                                      <Tab.Content className="pt-2">
                                                        {ListOfFormsPT?.length >
                                                        0
                                                          ? ListOfFormsPT?.map(
                                                              (item, index) => (
                                                                <Tab.Pane
                                                                  eventKey={
                                                                    item?.FormNo ==
                                                                    1
                                                                      ? "detail"
                                                                      : item?.FormNo ==
                                                                        2
                                                                      ? "material"
                                                                      : ""
                                                                  }
                                                                  key={index}
                                                                >
                                                                  <div
                                                                    className="card mb-2"
                                                                    style={{
                                                                      height:
                                                                        "auto",
                                                                    }}
                                                                  >
                                                                    <div className="card-body p-2">
                                                                      <Row>
                                                                        <Col
                                                                          lg={
                                                                            12
                                                                          }
                                                                        >
                                                                          <div className="table-responsive active-projects style-1 shorting mb-2">
                                                                            <div
                                                                              id="ParameterDetail-tbl_wrapper"
                                                                              className="dataTables_wrapper table-responsive no-footer"
                                                                            >
                                                                              {index ==
                                                                              0 ? (
                                                                                <table
                                                                                  id="ParameterDetail-tbl"
                                                                                  className="table table-bordered no-footer mb-0"
                                                                                >
                                                                                  <thead>
                                                                                    <tr>
                                                                                      <th width="2%">
                                                                                        Sr.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Ch.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Ch.
                                                                                        Date
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Offer
                                                                                        No
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Offer
                                                                                        Date
                                                                                      </th>
                                                                                      <th width="10%">
                                                                                        {test
                                                                                          ?.PTDetails[0]
                                                                                          .JobDescripationLabel
                                                                                          ? test
                                                                                              ?.PTDetails[0]
                                                                                              .JobDescripationLabel
                                                                                          : "Job Description"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        {test
                                                                                          ?.PTDetails[0]
                                                                                          .DPTNoLabel
                                                                                          ? test
                                                                                              ?.PTDetails[0]
                                                                                              .DPTNoLabel
                                                                                          : "Tested Area"}
                                                                                      </th>
                                                                                      <th
                                                                                        width="8%"
                                                                                        style={{
                                                                                          textTransform:
                                                                                            "none",
                                                                                        }}
                                                                                      >
                                                                                        {test
                                                                                          ?.PTDetails[0]
                                                                                          .HeatNoLabel
                                                                                          ? test
                                                                                              ?.PTDetails[0]
                                                                                              .HeatNoLabel
                                                                                          : "Size(mm)"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        {test
                                                                                          ?.PTDetails[0]
                                                                                          .JointNoLabel
                                                                                          ? test
                                                                                              ?.PTDetails[0]
                                                                                              .JointNoLabel
                                                                                          : "Joint No"}
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Qty
                                                                                      </th>
                                                                                      <th width="8%">
                                                                                        Observation
                                                                                      </th>
                                                                                      <th
                                                                                        width="8%"
                                                                                        style={{
                                                                                          textAlign:
                                                                                            "left",
                                                                                        }}
                                                                                      >
                                                                                        Result
                                                                                      </th>
                                                                                    </tr>
                                                                                  </thead>
                                                                                  <tbody>
                                                                                    {test
                                                                                      ?.PTDetails[0]
                                                                                      .ListOfTestingPTDetail
                                                                                      ?.length >
                                                                                    0 ? (
                                                                                      test?.PTDetails[0].ListOfTestingPTDetail?.map(
                                                                                        (
                                                                                          itemTest,
                                                                                          indxTest
                                                                                        ) => (
                                                                                          <tr
                                                                                            key={
                                                                                              indxTest
                                                                                            }
                                                                                          >
                                                                                            <td
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {indxTest +
                                                                                                1}
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.ChallanNo
                                                                                              }
                                                                                            </td>

                                                                                            <td>
                                                                                              {
                                                                                                itemTest.ChallanDate
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.OfferNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.OfferDate
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.JobDescripation
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.DPTNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.HeatNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.JointNo
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.Quantity
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest.Observation
                                                                                              }
                                                                                            </td>
                                                                                            <td
                                                                                              className="p-1"
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "left",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                itemTest.Result
                                                                                              }
                                                                                            </td>
                                                                                          </tr>
                                                                                        )
                                                                                      )
                                                                                    ) : (
                                                                                      <tr>
                                                                                        <td
                                                                                          colSpan={
                                                                                            13
                                                                                          }
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                        >
                                                                                          <div>
                                                                                            {
                                                                                              "No Record Found..."
                                                                                            }
                                                                                          </div>
                                                                                        </td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </tbody>
                                                                                </table>
                                                                              ) : index ==
                                                                                1 ? (
                                                                                <table
                                                                                  id="MaterialDetail-tbl"
                                                                                  className="table table-bordered no-footer mb-0"
                                                                                >
                                                                                  <thead>
                                                                                    <tr>
                                                                                      <th width="2%">
                                                                                        Sr.
                                                                                        No
                                                                                      </th>
                                                                                      <th width="15%">
                                                                                        Material
                                                                                      </th>
                                                                                      <th width="10%">
                                                                                        Manufacturer
                                                                                      </th>
                                                                                      <th width="13%">
                                                                                        Batch
                                                                                        No
                                                                                      </th>
                                                                                      <th
                                                                                        width="15%"
                                                                                        style={{
                                                                                          textAlign:
                                                                                            "left",
                                                                                        }}
                                                                                      >
                                                                                        Expiry
                                                                                        Date
                                                                                      </th>
                                                                                    </tr>
                                                                                  </thead>
                                                                                  <tbody>
                                                                                    {test
                                                                                      ?.PTDetails[0]
                                                                                      .ListOfTestingPTMaterialDetail
                                                                                      ?.length >
                                                                                    0 ? (
                                                                                      test?.PTDetails[0].ListOfTestingPTMaterialDetail?.map(
                                                                                        (
                                                                                          itemTest,
                                                                                          indxTest
                                                                                        ) => (
                                                                                          <tr
                                                                                            key={
                                                                                              indxTest
                                                                                            }
                                                                                          >
                                                                                            <td
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {indxTest +
                                                                                                1}
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest?.MaterialName
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest?.ManufacturerOfPowder
                                                                                              }
                                                                                            </td>
                                                                                            <td>
                                                                                              {
                                                                                                itemTest?.BatchNo
                                                                                              }
                                                                                            </td>
                                                                                            <td
                                                                                              className="p-1"
                                                                                              style={{
                                                                                                textAlign:
                                                                                                  "left",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                itemTest?.ExpiryDate
                                                                                              }
                                                                                            </td>
                                                                                          </tr>
                                                                                        )
                                                                                      )
                                                                                    ) : (
                                                                                      <tr>
                                                                                        <td
                                                                                          colSpan={
                                                                                            5
                                                                                          }
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                        >
                                                                                          <div>
                                                                                            {
                                                                                              "No Record Found..."
                                                                                            }
                                                                                          </div>
                                                                                        </td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </tbody>
                                                                                </table>
                                                                              ) : (
                                                                                ""
                                                                              )}
                                                                            </div>
                                                                          </div>
                                                                        </Col>
                                                                      </Row>
                                                                    </div>
                                                                  </div>
                                                                </Tab.Pane>
                                                              )
                                                            )
                                                          : ""}
                                                      </Tab.Content>
                                                    </Tab.Container>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            )}
                        </div>
                      </Accordion.Collapse>
                    </Accordion.Item>
                  ))}
                </Accordion>
                {showTCAllTestApprovalModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showTestMasterImagesModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showTestingResultImagesModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showLetterRefDocModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {showTPIDetailModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
                {/* {showDefineMoreRatesModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )} */}
              </Form>
            </FormikProvider>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button
              variant="secondary light"
              onClick={() => setShowTestingApprovalModal(false)}
            >
              Close
            </Button>
          </Modal.Footer> */}
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showTCAllTestApprovalModal}
        onHide={setShowTCAllTestApprovalModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Approve All</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTCAllTestApprovalModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <FormikProvider value={formikApproval}>
              <Form onSubmit={formikApproval.handleSubmit}>
                <Row>
                  <Col lg={12}>
                    <label className="mb-1">Instruction:</label>
                    <ul className="unorder-list ps-4 mb-2">
                      <li>
                        Selected TC included all test should be approve / revise
                        & rectify.
                      </li>
                      <li>
                        Approval note should be apply to all test of selected
                        TC.
                      </li>
                      <li>
                        Only Unapproved Test should be approve / revise &
                        rectify. Other remains as it is.
                      </li>
                    </ul>
                  </Col>
                  <Col lg={12}>
                    <Field
                      type="text"
                      name={"ApprovalNoteForApproveAll"}
                      component={CustomInput}
                      placeholder="Approval Note"
                      maxLength={100}
                    />
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              // className="btn btn-primary"
              className="btn btn-primary btn-sm"
              onClick={() => {
                ApproveRejectTCAllTest(4);
              }}
            >
              <i className="fa fa-circle-check"></i> Approve
            </button>
            &nbsp;
            <button
              type="button"
              // className="btn btn-danger light"
              className="btn btn-primary btn-sm"
              onClick={() => {
                ApproveRejectTCAllTest(5);
              }}
            >
              <i className="fa fa-rotate-left"></i> Revise & Rectify
            </button>
            <Button
              // variant="secondary light"
              variant="danger btn-sm"
              onClick={() => setShowTCAllTestApprovalModal(false)}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showTestMasterImagesModal}
        onHide={setShowTestMasterImagesModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Test Master Images</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTestMasterImagesModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive active-projects style-1 shorting mb-2">
              <div
                id="TestMasterImages-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="TestMasterImages-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="2%"></th>
                      <th width="98%" style={{ textAlign: "left" }}>
                        Image Preview
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listTestMasterImages?.length > 0 ? (
                      listTestMasterImages?.map((item, indx) => (
                        <tr>
                          <td>
                            <Link
                              to="#"
                              // className="icon-box icon-box-md bg-primary-light me-1"
                              className="icon-box icon-box-md me-1"
                              title="View"
                              onClick={() => {
                                window.open(item.ImageFilePath, "_blank");
                              }}
                            >
                              <i className="fa fa-eye"></i>
                            </Link>
                          </td>
                          <td>
                            <div
                              className="image-placeholder"
                              style={{
                                maxWidth: "100px",
                                margin: "10px",
                                zIndex: 0,
                              }}
                            >
                              <div
                                className="avatar-preview"
                                style={{
                                  width: "100px",
                                  height: "auto",
                                }}
                              >
                                <div id="testMasterImagePreview">
                                  <img
                                    id="saveTestMasterImageFile"
                                    src={item.ImageFilePath}
                                    alt={"Image"}
                                    onClick={() => {
                                      window.open(item.ImageFilePath, "_blank");
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showTestingResultImagesModal}
        onHide={setShowTestingResultImagesModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Testing Images</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTestingResultImagesModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive active-projects style-1 shorting mb-2">
              <div
                id="TestMasterImages-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="TestMasterImages-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="2%"></th>
                      <th width="98%" style={{ textAlign: "left" }}>
                        Image Preview
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listOfTestingResultImages?.length > 0 ? (
                      listOfTestingResultImages?.map((item, indx) => (
                        <tr>
                          <td>
                            <Link
                              to="#"
                              // className="icon-box icon-box-md bg-primary-light me-1"
                              className="icon-box icon-box-md me-1"
                              title="View"
                              onClick={() => {
                                window.open(item.ResultImagePath, "_blank");
                              }}
                            >
                              <i className="fa fa-eye"></i>
                            </Link>
                          </td>
                          <td style={{ textAlign: "left" }}>
                            <div
                              className="image-placeholder"
                              style={{
                                maxWidth: "100px",
                                margin: "10px",
                                zIndex: 0,
                              }}
                            >
                              <div
                                className="avatar-preview"
                                style={{
                                  width: "100px",
                                  height: "auto",
                                }}
                              >
                                <div id="resultImagePathPreview">
                                  <img
                                    id="saveResultImagePath"
                                    src={item.ResultImagePath}
                                    alt={"Image"}
                                    onClick={() => {
                                      window.open(
                                        item.ResultImagePath,
                                        "_blank"
                                      );
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <span className="fs-12">{item.Remarks}</span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showLetterRefDocModal}
        onHide={setShowLetterRefDocModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowLetterRefDocModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="MaterialPhotos-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="MaterialPhotos-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="2%"></th>
                          <th width="98%" style={{ textAlign: "left" }}>
                            File Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfLetterRefDoc?.length > 0 ? (
                          ListOfLetterRefDoc?.map((item, indx) => (
                            <tr key={indx}>
                              <td style={{ textAlign: "left" }}>
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="View"
                                  onClick={() => {
                                    window.open(
                                      item.LetterRefImageFilePath
                                        ? item.LetterRefImageFilePath
                                        : item.viewFile
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye" />
                                </Link>
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {item?.LetterRefImageFileName
                                  ? item?.LetterRefImageFileName
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showTPIDetailModal}
        onHide={setShowTPIDetailModal}
        size="lg"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>TPI Detail</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowTPIDetailModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="TPIdetail-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="TPIdetail-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="40%">TPI</th>
                          <th width="40%">TPI Contact Person</th>
                          <th width="20%" style={{ textAlign: "left" }}>
                            TPI Expected Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {listOfTPIDetails?.length > 0 ? (
                          listOfTPIDetails?.map((item, indx) => (
                            <tr key={indx}>
                              <td>{item.TPIName}</td>
                              <td>{item.TPIContactPersonName}</td>
                              <td style={{ textAlign: "left" }}>
                                {item.TPIExpectedDate}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={4} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTPIDetailModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
        </Spin>
      </Modal>

      {/* <Modal
        className="fade"
        show={showDefineMoreRatesModal}
        onHide={setShowDefineMoreRatesModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikDefineMoreRates}>
            <Form onSubmit={formikDefineMoreRates.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Define More Rates</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="DefineMoreRates-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="DefineMoreRates-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead className="fixedheader">
                            <tr>
                              <th width="5%" className="ps-1"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Rate Type
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {MoreTestRatesList?.length > 0 ? (
                              MoreTestRatesList?.map((tRate, tRateindx) => (
                                <tr key={`para_${tRateindx}`}>
                                  <td className="p-1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkIsSelected${tRateindx}`}
                                      name={`chkIsSelected${tRateindx}`}
                                      checked={tRate.IsSelected}
                                      disabled={true}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    {tRate.RateTypeName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={2}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
            
            </Form>
          </FormikProvider>
        </Spin>
      </Modal> */}
    </>
  );
};

export default TestingNDTApproval;
